import React from 'react';

export default function PayRun() {
  return (
    <div>PayRun</div>
  );
}
